module.exports = __webpack_public_path__ + "img/pix-logo.3bcca5c7.png";